import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { Link as link, browserHistory} from 'react-router';
import { bindActionCreators } from 'redux';
import * as SelectionActions from '../../actions/Selection.js';
import Helpers from '../../helpers';

const Link = radium(link);

const styles = {
  contentWrap: {
    padding: '0 24px',
    '@media (max-width: 800px)': {
      marginBottom: 44,
    },
  },
  title: {
    color: '#a39671',
    padding: '24px 0 12px 0',
    fontSize: 18,
    fontWeight: 300,
    margin: 0,
    letterSpacing: 5,
  },
  list: {
    margin: '0 -12px',
    padding: 0,
    display: 'flex',
    width: 'calc(100% + 24px)',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  list_TV: {
    margin: '0 7%',
    padding: 0,
    display: 'flex',
    width: 'calc(100% + 24px)',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  item: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: 347,
    height: 304,
    margin: 12,
    border: '1px solid #9b9b9b',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center, center',
    ':hover': {
      border: '3px solid #fbbb0c',
      padding: 12,
    },
  },
  item_TV: {
    cursor: 'pointer',
    textDecoration: 'none',
    width: '40%',
    height: '450px',
    margin: 12,
    border: '1px solid #9b9b9b',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: 14,
    fontSize: 18,
    color: '#4a4a4a',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center, center',
    ':hover': {
      border: '3px solid #fbbb0c',
      padding: 12,
    },
  },
  selected: {
    border: '3px solid #fbbb0c',
    padding: 12,
  },
  bottom: {
    position: 'fixed',
    bottom: 60,
    height: 44,
    color: '#fff',
    backgroundColor: '#9b9b9b',
    width: 'calc(100% - 250px)',
    padding: '0 24px',
    '@media (max-width: 800px)': {
      position: 'fixed',
      width: '100%',
    },
  },
  bottom_TV: {
    position: 'fixed',
    bottom: 60,
    height: 44,
    color: '#fff',
    backgroundColor: '#9b9b9b',
    width: '100%',
    padding: '0 24px',
  },
  link: {
    fontSize: 18,
    fontWeight: 100,
    height: 44,
    lineHeight: '44px',
    padding: 0,
    display: 'inline-block',
    color: '#fff',
    textDecoration: 'none',
  },
  right: {
    float: 'right',
  },
  spacer: {
    flex: 1,
  },
};

class SelectionCharacterList extends Component {
  constructor(props) {
    super(props);

    if (!props.location.query || isNaN(props.location.query.type)) {
      props.backToTypeSelection();
    } else {
      this.state = {
        selectedCharacterId: null,
        typeId: parseInt(props.location.query.type, 10),
      };
    }
  }

  componentWillMount() {
    const {
      fetchSelectionDetail,
    } = this.props;

    const {
      typeId,
    } = this.state;

    fetchSelectionDetail(typeId);
  }

  render() {
    const {
      characters,
    } = this.props;

    const {
      selectedCharacterId,
      typeId,
    } = this.state;
    
    var item = styles.item;
    var list = styles.list;
    var bottom = styles.bottom;

    if (Helpers.Session.isViaTV()) {
      item = styles.item_TV;
      list = styles.list_TV;
      bottom = styles.bottom_TV;
    }

    var next = <Link
    to={`/selections/colors?type=${typeId}&character=${selectedCharacterId}`}
    onClick={(e) => {
      if (!selectedCharacterId) e.preventDefault();
    }}
    style={[styles.link, styles.right]}>下一步</Link>

    if (Helpers.Session.isViaTV()) {
      next = null;
    }

    return (
      <div style={styles.wrap}>
        <div style={styles.contentWrap}>
          <h1 style={styles.title}>請選擇人物：</h1>
          <div style={list}>
            {characters.map(character => (
              <div
                onClick={() => {
                  if (Helpers.Session.isViaTV()) {
                    browserHistory.push(`/selections/colors?type=${typeId}&character=${character.id}`);
                  }else {
                    this.setState({ selectedCharacterId: character.id });
                  }
                }}
                style={[
                  item,
                  selectedCharacterId === character.id && styles.selected,
                  {
                    backgroundImage: `url(${character.cover})`,
                  },
                ]}
                key={character.id}></div>
            ))}
          </div>
        </div>
        <div style={bottom}>
          <Link
            to="/selections"
            style={styles.link}>上一步</Link>
          <span style={styles.spacer} />
          {next}
        </div>
      </div>
    );
  }
}

SelectionCharacterList.propTypes = {
  characters: T.array,
  fetchSelectionDetail: T.func,
  location: T.shape({
    query: T.shape({
      type: T.string,
    }),
  }),
  backToTypeSelection: T.func,
};

export default connect(
  state => ({
    characters: state.Selection.characters,
  }),
  dispatch => bindActionCreators(SelectionActions, dispatch),
)(radium(SelectionCharacterList));



// WEBPACK FOOTER //
// ./containers/Selections/SelectionCharacterList.js